/* Register */
import ConsentRenewalShowPage from "@/components/gdpr/ConsentRenewalShowPage.vue";
export default {
  path: "/register/customers/:id",
  component: ConsentRenewalShowPage,
  name: "EmailManagementForConsentRenewalShowPage",
  meta: {
    breadcrumb: "register",
    layout: "UUIDLayout"
  }
};
